export default {
  'get-list': {
    method: 'post',
    url: '/client/commodity/list'
  },
  add: {
    method: 'post',
    url: '/client/commodity'
  },
  delete: {
    method: 'delete',
    url: '/client/commodity'
  },
  update: {
    method: 'put',
    url: '/client/commodity/ID'
  },
  find: {
    method: 'get',
    url: '/client/partner/commodity/COOPERATOR/find?key=KEY'
  },
  findByOpportunity: {
    method: 'get',
    url: '/client/partner/commodity/COOPERATOR/find/OPPORTUNITY?key=KEY'
  }
}
